import React, { useState, useEffect, useContext } from 'react';
import { GlobalContext, useGlobalContext } from '../../context/GlobalContext';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import { usePayment } from '../../context/PaymentContext';
import { useCartContext } from '../../context/CartContext';
import './Payment.css';
import { formatDateTime } from '../../utils/DateUtils';

const PaymentResult = () => {
  const { t } = useTranslation();
  const { goToStep } = useContext(GlobalContext);
  const { formatAmounts, store, step, prepareTracking, currentLanguage } = useGlobalContext();
  const { setCart } = useCartContext();
  const { checkTransaction } = usePayment();
  const { status, reference } = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  const [order, setOrder] = useState(() => {
    const storedOrderData = sessionStorage.getItem('orderData');
    if (storedOrderData) {
      const parsed = JSON.parse(storedOrderData);
      if (parsed.order) {
        return { ...parsed.order, status: status || 'pending' };
      }
    }
    return {};
  });
  const [ready, setReady] = useState(false);
  const [loading, setLoading] = useState(true);
  const [waitingLong, setWaitingLong] = useState(false);

  const lang = currentLanguage?.code ? currentLanguage.code : store.default_language;

  useEffect(() => {
    const timer = setTimeout(() => setReady(true), 1200);
    const longWaitTimer = setTimeout(() => setWaitingLong(true), 0);
    return () => {
      clearTimeout(timer);
      clearTimeout(longWaitTimer);
    };
  }, []);

  useEffect(() => {
    if (loading == false && ready) {
      if (step == 1 || step == 2) {
        navigate("/")
      }
    }
  }, [step]);

  useEffect(() => {
    const verifyTransaction = async () => {
      let transactionReference = reference;

      goToStep(3);
      try {
        setLoading(true);
        const storedOrderData = sessionStorage.getItem('orderData');
        const storedOrder = storedOrderData ? JSON.parse(storedOrderData).order : null;
        const queryParams = new URLSearchParams(location.search);

        if (storedOrder && storedOrder.ref) {
          console.log("tracking :", status)
          prepareTracking(status);
          transactionReference = storedOrder.ref;
        } else if (!transactionReference) {
          if (queryParams.has('response_order_id')) {
            transactionReference = queryParams.get('response_order_id');
          } else {
            const possibleRefParams = ['orderID', 'ref', 'ORDERID', 'id'];
            for (const paramName of possibleRefParams) {
              if (queryParams.has(paramName)) {
                transactionReference = queryParams.get(paramName);
                break;
              }
            }
          }
        }

        if (status !== 'canceled') {
          const result = await checkTransaction(
            transactionReference,
            status,
            Object.fromEntries(queryParams.entries())
          );

          console.log('[PaymentResult] URL status:', status);
          console.log('[PaymentResult] URL reference:', transactionReference);
          console.log('[PaymentResult] URL params:', Object.fromEntries(queryParams.entries()));
          console.log('[PaymentResult] API result:', JSON.stringify(result, null, 2));

          if (result.status === 'exception') {
            setOrder({ status: 'exception', exception: result.errors });
          } else if (result.cards) {
            sessionStorage.removeItem('totalAmounts');
            sessionStorage.removeItem('cart');
            sessionStorage.removeItem('promoCode');
            sessionStorage.removeItem('promoDiscount');
            setCart({ items: [] });

            setOrder({
              ...result,
              cards: result.cards,
              status: status === "result" ? result.cards[0].status : status,
              store: result.cards[0].physical_cart_group ? 'physical' : 'digital'
            });
          } else {
            setOrder({ status: 'exception', exception: [{ message: 'Commande introuvable' }] });
          }
        } else {
          setOrder({ status: 'canceled' });
          const cartData = sessionStorage.getItem('cart');
          if (cartData) {
            setCart(JSON.parse(cartData));
          } else {
            setCart({ items: [] });
          }
        }
      } catch (error) {
        console.log('verifyTransaction : exception', error);
        setOrder({ status: 'exception', exception: [{ message: error.message }] });
      } finally {
        setLoading(false);
      }
    };

    verifyTransaction();
  }, [status, reference, location.search]);

  const goPanier = (e) => {
    e.preventDefault();
    goToStep(2);
    setTimeout(() => {
      window.location.href = "/home"
    }, 500);
  };

  const goToHomeAndSave = (e) => {
    e.preventDefault();
    goToStep(1);
    setTimeout(() => {
      window.location.href = "/home"
    }, 500);
  };

  const handleConfirmationRedirect = (e) => {
    e.preventDefault();
    if (store.confirmationRedirect) {
      window.open(store.confirmationRedirect, '_blank', 'noopener,noreferrer');
    }
  };

  if (loading || !ready) {
    return (
      <>
        <div id="topSection" className="ng-scope" role="region">
          <div className={`overlayBox ${store.mainImageFilter ? 'overlay' : ''}`}>
            <div className="wrapper">
              <div className="headContent">&nbsp;</div>
            </div>
          </div>
        </div>
        <div className="mainContent step-result" style={{ marginTop: 0 }}>
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '60px 20px' }}>
            <div style={{ width: '150px', height: '150px', position: 'relative' }}>
              <div id="loader" style={{ position: 'absolute', top: 0, left: 0, margin: 0 }}></div>
            </div>
            {waitingLong && (
              <p className="typo" style={{ textAlign: 'center', marginTop: '20px', color: '#555' }}>
                {t('Vérification de votre paiement en cours, veuillez patienter...')}
              </p>
            )}
          </div>
        </div>
      </>
    );
  }


  if (order?.status !== 'authorized') {
    return (
      <>
        <div id="topSection" className="ng-scope" role="region">
          <div className={`overlayBox ${store.mainImageFilter ? 'overlay' : ''}`}>
          </div>
        </div>
        <div className="mainContent step-result">
          <div className="wrapper mainWhiteBox">
            <div className="contentBody mainColor typoBold">
              <div className="rfConfirmation errorsItems" role="alert">
                {order?.status === 'refused' && <div className="error">{t('Votre paiement a été refusé')}</div>}
                {order?.status === 'canceled' && <div className="error">{t('Vous avez annulé votre paiement')}</div>}
                {order?.status === 'incomplete' && (
                  <div className="error">
                    {t("Votre paiement n'a pas pu aboutir.")}
                    <br />
                    {t('Veuillez réessayer')}
                  </div>
                )}
                {order?.status === 'unpayed' && <div className="error">{t('Paiement non effectué')}</div>}
                {order?.status === 'exception' && order.exception?.map((err, index) => (
                  <div key={index} className="error">{err.message}</div>
                ))}
              </div>
              <div className="toHomeAction">
                <button onClick={goPanier} className="primaryButton rfBtn">
                  {t('Retour à ma commande')}
                </button>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <div id="topSection" className="ng-scope" role="region" aria-labelledby="confirmation-message">
        <div className={`overlayBox ${store.mainImageFilter ? 'overlay' : ''}`}>
          {order?.status === 'authorized' && (
            <div className="wrapper">
              <h1 id="confirmation-message" className="headContent">
                {store.confirmationAccrocheText && store.confirmationAccrocheText[lang] ? (
                  <span dangerouslySetInnerHTML={{ __html: store.confirmationAccrocheText[lang] }} />
                ) : (
                  t('Votre commande a été enregistrée avec succès ! Gardez précieusement ces informations.')
                )}
              </h1>
            </div>
          )}
        </div>
      </div>
      <div className="mainContent step-result">
        {order?.status === 'authorized' && ready && order?.cards && order.cards.length > 0 && (
          <div className="wrapper authorized ng-scope">
            <div className="orderConfirmation typo">
              <section id="confirmation-section" tabIndex="-1" className="confirmationBox mainWhiteBox confirmationIntro" aria-labelledby="confirmation-title">
                <h2 id="confirmation-title" className="confirmationTitle">
                  {t('Merci pour votre commande !')}
                </h2>
                <p className="confirmationMessage">
                  {t('Un email de confirmation et un récapitulatif a été envoyé à :')}
                  <br />
                  <span className="typoBold">{order.cards[0]?.emailSender}</span>
                </p>
                <p className="confirmationRef">
                  {t("Votre numéro de transaction est le")}{' '}
                  <span className="typoBold">{order.cards[0]?.idTransaction}</span>
                </p>
                {order.store === 'digital' && store?.video_enabled && order.cards[0]?.videoCode && (
                  <p className="videoMessage typoMedium font">
                    {t('Cliquez sur ce lien pour ajouter une vidéo à cette carte')}{' '}
                    <a
                      href={`${store?.video_url_buyer || '#'}${order.cards[0]?.videoCode}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn-video mainColor"
                      aria-label={`${t('Ajouter une vidéo')} (${t('S\'ouvre dans un nouvel onglet')})`}
                      onClick={(e) => {
                        if (!store?.video_url_buyer) {
                          e.preventDefault();
                          console.log('URL vidéo non disponible');
                        }
                      }}
                    >
                      {t('Ajouter une vidéo')}
                      <span className="sr-only"> ({t('S\'ouvre dans un nouvel onglet')})</span>
                    </a>
                  </p>
                )}
              </section>

              <section id="cards-section" tabIndex="-1" className="orderDetails" aria-labelledby="cards-section-title">
                <h2 id="cards-section-title" className="cardsCountHead">
                  {order.cards.length}{' '}
                  {order.store === 'physical' ? t('carte cadeau') : t('e-carte cadeau')}
                </h2>
                {order.cards.map((card, index) => (
                  <div key={index} className="card-item">
                    {renderCardContent(card)}
                  </div>
                ))}
              </section>

              <div id="actions-section" tabIndex="-1" className="actionButtons" aria-labelledby="actions-section-title">
                <h3 id="actions-section-title" className="sr-only">{t('Actions disponibles')}</h3>
                {order.pdf && order.cards.length > 1 && (
                  <a
                    href={order.pdf}
                    download
                    target="_blank"
                    rel="noopener noreferrer"
                    className="rfBtn buyOther typo"
                    aria-label={`${t('Télécharger toutes mes cartes')} (${t('S\'ouvre dans un nouvel onglet')})`}
                  >
                    {t('Télécharger toutes mes cartes')}
                  </a>
                )}

                <button
                  className="rfBtn sendOrder typo"
                  onClick={goToHomeAndSave}
                >
                  {t('Acheter une autre e-carte cadeau')}
                </button>

                {store.confirmationRedirect && store.confirmationRedirectButton && store.confirmationRedirectButton[lang] && (
                  <button
                    className="rfBtn confirmationRedirect typo"
                    onClick={handleConfirmationRedirect}
                  >
                    {store.confirmationRedirectButton[lang]}
                  </button>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );

  function renderCardContent(card) {
    return (
      <article className="payment-card-container">
        <div className="payment-card-image-container">
          <img
            loading="lazy"
            src={card.card?.src}
            alt={`${t('Aperçu de la carte cadeau')} ${store.libelle}`}
            className="payment-card-image"
          />
        </div>
        <div className="payment-card-info">
          <div className="payment-card-value typoBold">
            {formatAmounts(card.amountAfterDiscount, 2, store)}
            {card.isDiscountGifted && (
              <span className="badge-offerte">{t('Offerte')}</span>
            )}
          </div>
          <div className="payment-card-delivery-info font">
            {order.store === 'digital' && card.emailReceiver !== card.emailSender && card.sentDate && (
              <>
                {t('La e-carte sera envoyée par email le :')} {' '}
                {moment.unix(card.sentDate.timestamp).format('DD/MM/YYYY')} {' '}
                {t('à')} {' '}
                <span className="time-display">
                  {(() => {
                    const momentTime = moment.unix(card.sentDate.timestamp);
                    const formattedTime = momentTime.format(store.format_time);
                    const timezoneOffset = momentTime.format('Z');
                    const gmtOffset = timezoneOffset.substring(0, 3);
                    return (
                      <>
                        {' '}{formattedTime}
                        <span className="timezone-small"> GMT{gmtOffset}</span>
                      </>
                    );
                  })()}
                </span>
              </>
            )}
            {order.store === 'digital' && card.emailReceiver === card.emailSender && (
              t('Remise en main propre')
            )}
            {order.store === 'physical' && (
              t('Envoyée prochainement')
            )}
          </div>
          {(card.firstNameReceiver || card.lastNameReceiver) && (
            <p className="payment-card-beneficiary-name typoMedium">
              {card.firstNameReceiver} {card.lastNameReceiver}
            </p>
          )}
          {card.emailReceiver && (
            <p className="payment-card-beneficiary-email">{card.emailReceiver}</p>
          )}
          {card.message && (
            <>
              <div className="payment-card-separator" aria-hidden="true"></div>
              <p className="payment-card-message-content font">{card.message}</p>
            </>
          )}
        </div>
        {card.dl && (
          <a
            href={card.dl}
            download={`carte-cadeau-${store.libelle.replace(/\s+/g, '-').toLowerCase()}.pdf`}
            target="_blank"
            rel="noopener noreferrer"
            className="rfBtn payment-card-download"
            aria-label={`${t('Télécharger ma carte')} ${store.libelle} (${t('S\'ouvre dans un nouvel onglet')})`}
          >
            {t('Télécharger')}
            <span className="sr-only"> ({t('S\'ouvre dans un nouvel onglet')})</span>
          </a>
        )}
      </article>
    );
  }
}

export default PaymentResult;